var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsers = function SvgUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.5 10.5v-1a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v1m11 0v-1A2 2 0 0 0 10 7.565m-2-6A2 2 0 0 1 8 5.44M6.5 3.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
  })));
};
export default SvgUsers;